import { batchQueryStoresList, getAdminStoresByIds } from 'services/api/admin';
import {
  mapStoresToProductStoreDisplays,
  mapStoreScopesToProductStoreScopes,
  productStoreKey,
} from '../model/mappers';
import type { ProductStoreIdentity } from '../model/types';

export const resolveProductStoreScopes = async (scopes: General.StoreScope[]) => {
  const storeIds = [
    ...new Set(
      scopes.flatMap((scope) =>
        scope.regionStoreScopes.flatMap((regionScope) => regionScope.storeIds ?? []),
      ),
    ),
  ];
  const stores = storeIds.length ? (await getAdminStoresByIds(storeIds)).stores : [];

  return mapStoreScopesToProductStoreScopes(scopes, stores);
};

export const resolveProductStoreDisplays = async (identities: ProductStoreIdentity[]) => {
  // 跨平台/站点合并为一次批量查询（对齐 perseus 商品概览页面逻辑优化）；
  // 店铺名称为展示增强，查询失败时沿用 externalStoreId 回退，不阻断商品列表
  const uniqueIdentities = new Map<string, ProductStoreIdentity>();
  for (const identity of identities) {
    if (!identity.platform || !identity.region || !identity.externalStoreId) continue;
    uniqueIdentities.set(productStoreKey(identity), identity);
  }
  if (!uniqueIdentities.size) return {};

  try {
    const stores = await batchQueryStoresList({
      batchQueryStoreList: [...uniqueIdentities.values()].map((identity) => ({
        externalType: identity.platform,
        region: identity.region,
        externalId: identity.externalStoreId,
      })),
    });

    return mapStoresToProductStoreDisplays(stores);
  } catch {
    return {};
  }
};
